import React from "react";

interface SvgWithTextProps {
  label: string; // 显示的文字
  fontSize?: number; // 字号，默认 16
  color?: string; // 字体颜色，默认黑色
}

const SvgWithText: React.FC<SvgWithTextProps> = ({
  label,
  fontSize = 16,
  color = "black",
}) => {
  return (
    <svg
      width="100%"
      height="auto"
      viewBox="0 0 343 60"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 背景图形 */}
      <path
        d="M169.112 2.41113C170.457 1.15678 172.543 1.15678 173.888 2.41113L180.726 8.79004C181.559 9.56721 182.656 10 183.795 10H337C340.038 10 342.5 12.4624 342.5 15.5V54C342.5 57.0374 340.037 59.5 337 59.5H6C2.96257 59.5 0.500214 57.0374 0.5 54V15.5C0.5 12.4624 2.96243 10 6 10H159.205C160.344 10 161.441 9.5672 162.274 8.79004L169.112 2.41113Z"
        fill="white"
        stroke="#E2E2E2"
      />
      {/* 使用 foreignObject 实现 padding */}
      <foreignObject x="10" y="10" width="323" height="40">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            padding: "20px 10px 10px 10px",
            boxSizing: "border-box",
            color: color,
            fontSize: `${fontSize}px`,
          }}
        >
          {label}
        </div>
      </foreignObject>
    </svg>
  );
};

export default SvgWithText;
